<template>
  <div v-if="item.id" @click="onChange" v-b-tooltip :title="item.title" class="film-item rounded align-items-center" >
    <b-rating :value="item.score / 2" inline no-border precision="2" class="no-backcolor" variant="warning" readonly size="sm" />
    <div v-if="selected" class="film-item-selected-state-wrapper position-absolute d-flex flex-column justify-content-center align-items-center">
      <i class="fa fa-check-circle text-white"></i>
    </div>
    <div class="bottom-title-wrapper position-absolute">
      <div class="bottom-title text-truncate">{{ item.title }}</div>
    </div>
    <b-img class="film-img align-content-center" :style="[!item.cover_image_preview ? `transform: scale(1.7);` : '']" fluid rounded :src="item.cover_image_preview || 'assets/media/misc/bg-2.jpg'" />
  </div>
</template>

<script>
  export default {
    name: "FilmItem",
    props: {
      item: {
        type: Object,
        default: ()=> {return {}}
      },
      index: {
        type: [Number, String],
      },
      selected: {
        type: Boolean
      }
    },
    computed: {
      backgroundImage(){
        return this.item.cover_image_preview ? this.item.cover_image_preview : '/assets/media/misc/bg-2.jpg';
      },
    },
    methods: {
      onChange(e){
        let { index, item } = this;
        this.$emit('changed', {index, film: item});
      }
    }
  }
</script>

<style >
  .film-item {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    box-shadow: 0 0 13px 0 rgba(82,63,105,0.05);

    background-color: #ffffff;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;

    overflow: hidden;
    height: 150px;
    position: relative;
  }

  .film-item .film-img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  .film-item.rounded{
    border-radius: 6px;
  }

  .film-item-selected-state-wrapper {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }

  .film-item-selected-state-wrapper i.fa {
    font-size: 42px;
  }

  .film-item .bottom-title-wrapper {
    bottom: 0;
    left: 5px;
    right: 5px;
    z-index: 1;
    height: 25px;
  }

  .bottom-title {
    position: relative;
    z-index: 2;
    color: white;
    text-shadow: 0 0 2px black;
    text-align: center;
    font-size: 14px;
    line-height: 1.4;
  }

  .no-backcolor {
    background-color: unset !important;
    z-index: 1;
  }
</style>
